import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';

import { FormattedMessageWrappedInSpan } from '../../misc';
import SubsectionInFrame from '../../misc/SubsectionInFrame';
import { FACTOR_EMAIL } from '../../../utils/variables';

const InactiveEventInfo = ({ eventInfo, onGoToAuthentication }) => {
  const shouldShowPossibleAuthentication =
    !eventInfo.participantUser && eventInfo.secondFactorType?.type === FACTOR_EMAIL;

  return (
    <SubsectionInFrame
      lastInRow
      topPadding
      center
      gap={20}
      noBottomPadding={shouldShowPossibleAuthentication}
    >
      <div dangerouslySetInnerHTML={{ __html: eventInfo.noMainSearchText }} />
      {shouldShowPossibleAuthentication && (
        <button
          className="btn primary-new full-width subsection-action-button"
          onClick={onGoToAuthentication}
        >
          <FormattedMessageWrappedInSpan
            id="inactiveEventInfo.authenticateBtn"
            defaultMessage="Authenticate"
          />
        </button>
      )}
    </SubsectionInFrame>
  );
};

InactiveEventInfo.propTypes = {
  eventInfo: PropTypes.object,
  onGoToAuthentication: PropTypes.func,
};

export { InactiveEventInfo };

export default createFragmentContainer(InactiveEventInfo, {
  eventInfo: graphql`
    fragment InactiveEventInfo_eventInfo on Event {
      noMainSearchText
      participantUser
      secondFactorType {
        type
      }
    }
  `,
});
